<template>
  <v-container>
    <sub-navigation-obchody v-if="me.spolupracovnik"></sub-navigation-obchody>
    <v-layout row wrap :class="{ 'mt-2': !me.spolupracovnik }">
      <v-flex xs12>
        <!-- <h1 class="h2 mb-30">Obchody a&nbsp; provize</h1> -->
        <v-dialog
          v-model="dialogInvoice"
          max-width="700px"
          transition="dialog-transition"
          v-if="dialogInvoice"
          persistent
        >
          <v-card class="no__padding">
            <v-card-title class="pa-0" :class="{'pa-3': $vuetify.breakpoint.smAndDown}">
              <v-layout row wrap>
                <v-flex grow>
                  <h2 class="mt-2">Souhlasíte s následující provizí?</h2>
                </v-flex>
                <v-flex shrink>
                  <v-btn color="primary" fab flat @click="dialogInvoice=false" small class="ma-0"><v-icon>close</v-icon></v-btn>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-text class="pa-0 mt-3" :class="{'pa-2': $vuetify.breakpoint.smAndDown}">
              <p class="mb-0 pb-0">Celková provize <strong>{{obdobi_ke_schvaleni.celkem_castka | formatMoney}} Kč</strong></p>
              <v-data-table
                :headers="vyuctovani_provize_headers"
                :items="obdobi_ke_schvaleni.polozky"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
                item-key="typ_polozky"
                hide-headers
                class="mt-3 mb-3"
              >
              <template v-slot:items="props">
                <td>
                  <span v-if="props.item.typ_polozky=='zlato'">Provize dle smlouvy o obchodním zastoupení za zlato</span>
                  <span v-if="props.item.typ_polozky=='stribro'">Provize dle smlouvy o obchodním zastoupení za stříbro</span>
                  <span v-if="props.item.typ_polozky=='kancelar'">Provize dle smlouvy o obchodním zastoupení za kancelář</span>
                </td>
                <td class="text-xs-right">{{ props.item.castka | formatMoney }} Kč</td>
              </template>
              </v-data-table>
            </v-card-text>
            <!-- <v-card-text class="pa-0 mt-3" :class="{'pa-2': $vuetify.breakpoint.smAndDown}" v-else>
              <p class="text-xs-center bold ma-4 green--text">Děkujeme za Vaši zprávu.</p>
            </v-card-text> -->
            <v-card-actions class="pa-0 mt-3" :class="{'pa-3 mt-0': $vuetify.breakpoint.smAndDown}">
              <v-spacer></v-spacer>
              <v-btn color="green elevation-0" class="bold" dark @click="approveInvoice" :loading="savingApproval" v-if="!savingDeny">Ano</v-btn>
              <v-btn color="red elevation-0" dark class="bold" @click="denyInvoice" :loading="savingDeny" v-if="!savingApproval">Ne</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="downloadXlsx"
          max-width="500px"
          transition="dialog-transition"
          v-if="me.makler && downloadXlsx"
        >
          <v-card>
            <v-card-title primary-title>
              <h2>Stáhnout přehled obchodů</h2>
            </v-card-title>
            <v-card-text>
              <p class="mx-3"><strong>Za období:</strong></p>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-menu offset-y right v-model="menu" :close-on-content-click="false" class="mx-2 d-flex grow">
                    <v-text-field
                      label="Datum"
                      v-model="datum"
                      slot="activator"
                      readonly
                      class="mx-0"
                      :class="{'mx-2': $vuetify.breakpoint.smAndUp}" clearable
                    ></v-text-field>
                    <v-card>
                      <v-card-text>
                        <DateRangePicker
                          :options="dateRangeOptions"
                          @input="onDateRangeChange"
                          :labels="labels"
                          @close="menu=false"
                        />
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="orange" depressed dark @click="download"><v-icon small class="mr-2">cloud_download</v-icon><strong>Stáhnout</strong></v-btn>
              <v-btn color="grey lighten-3" depressed @click="downloadXlsx=false">Zavřit</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-layout row wrap class="shop-layout" :class="{'mt-3': $vuetify.breakpoint.smAndDown}">
          <v-flex xs12 sm6 class="px-3">
            <div class="wallet-state credit-state credit-state__active">
              <div>
                <p class="text-white mb-2 bold">Očekávané provize</p>
                <p class="text-white ma-0 fs-12"><strong>Předběžné provize z&nbsp;nezaplacených objednávek</strong></p>
              </div>
              <h3 class="h1 text-white">{{nezauctovane | formatMoney}} Kč</h3>
            </div>
          </v-flex>
          <v-flex xs12 sm6 class="px-3">
            <div class="wallet-state credit-state credit-state__active">
              <div>
                <p class="text-white mb-2 bold">Přiznané provize</p>
                <p class="text-white ma-0 fs-12"><strong>Vyplacené a&nbsp;zaúčtované provize</strong></p>
              </div>
              <h3 class="h1 text-white">{{zauctovane | formatMoney}} Kč</h3>
            </div>
          </v-flex>
        </v-layout>
        <v-layout v-if="obdobi_ke_schvaleni != null" row wrap class="mt-1 mb-1">
          <v-flex xs12>
            <v-card class="px-3 pt-3 pb-0 elevation-0 mb-4">
              <v-card-title primary-title class="pa-0 mb-4 pl-2 mt-2">
                <h3>Provize ke schválení:</h3>
              </v-card-title>
              <v-layout row wrap class="px-2__row">
                <v-flex xs12 class="px-3">
                  <strong>Máte zde připravenou provizi ke schválení:</strong>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="px-2__row mt-3 pb-4">
                <v-flex sm6 class="px-3">
                  Celková provize <strong>{{obdobi_ke_schvaleni.celkem_castka | formatMoney}} Kč</strong>
                </v-flex>
                <v-flex sm6 class="px-3 text-xs-right">
                  <v-btn color="orange" dark depressed large @click="dialogInvoice=true"> Zadat moje vyjádření</v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="shop-layout mb-20">
          <v-flex xs12 class="ml-2 px-2" :class="{'mb-2 ml-4': $vuetify.breakpoint.smAndUp}">
            <v-layout row wrap align-center>
              <v-flex shrink class="pr-2">
                <strong>Filtr <v-icon color="orange" class="filter-img">sort</v-icon></strong>
              </v-flex>
              <v-flex sm4 class="pl-3" :class="{'pl-1': $vuetify.breakpoint.smAndDown}">
                <v-text-field
                  label="Hledáte něco konkrétního?"
                  autocomplete
                  solo
                  hide-details
                  append-icon="search"
                  v-model="search"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-flex xs12 class="ml-2 mb-2">
          <strong>Nevyřízené:</strong>
        </v-flex>
        <v-data-table
          :headers="headers"
          :items="items"
          class="elevation-0 mb-30"
          :loading="loadingTable"
          :pagination.sync="pagination"
          :total-items="totalItems"
          :rows-per-page-items="[25, 50, 100, 200]"
        >
          <template v-slot:items="props">
            <td>{{ props.item.datum | formatSimpleDate }}</td>
            <td>
              <span v-if="props.item.klient != null">
                {{ props.item.klient.nazev_osoby }}
              </span>
              <span v-else>
                --
              </span>
            </td>
            <td><span v-if="props.item.podrizeny_pracovnik">{{ props.item.obchodnik.nazev_osoby }}</span><span v-else>--</span></td>
            <td>
              <span v-if="props.item.ucel_platby=='sporici'">Postupný nákup</span>
              <span v-else-if="props.item.ucel_platby=='sporeni'">Postupný nákup</span>
              <span v-else-if="props.item.ucel_platby=='jednorazovy_nakup'">Jednorázový nákup</span>
            </td>
            <td class="text-xs-right">{{ props.item.objem_obchodu| formatMoney }} Kč</td>
            <td class="text-xs-right">{{ props.item.kredity| formatMoney }} kr.</td>
            <td class="text-xs-right">{{ props.item.hodnota_kreditu| formatMoneyInt }} Kč</td>
            <td class="text-xs-right">{{ props.item.castka| formatMoney }} Kč</td>
          </template>
        </v-data-table>
        <v-layout row wrap align-baseline>
          <v-flex grow class="ml-2 mb-2">
            <strong>Zúčtovaná období:</strong>
          </v-flex>
          <v-flex shrink v-if="me.makler">
            <v-btn color="orange" class="ma-0 mb-2" depressed dark @click="downloadXlsx=true"><v-icon class="mr-2" small>cloud_download</v-icon>Přehled obchodů</v-btn>
          </v-flex>
        </v-layout>
        <v-data-table
          :headers="obdobiHeaders"
          :items="zauctovane_obdobi"
          class="elevation-0"
          hide-actions
        >
          <template v-slot:items="props">
            <td>{{ props.item.rok }} / {{props.item.mesic}}</td>
            <td class="text-xs-right">{{ props.item.objem_obchodu | formatMoney }} Kč</td>
            <td class="text-xs-right">{{ props.item.celkem_kredity | formatMoney }} kr.</td>
            <td class="text-xs-right">{{ props.item.hodnota_kreditu | formatMoneyInt }} Kč</td>
            <td class="text-xs-right">{{ props.item.celkem_castka | formatMoney }} Kč</td>
            <td class="text-xs-center">
              <a :href="$salesmanInvoicesBaseUrl+props.item.faktura_s3" target="_blank" v-if="props.item.faktura_s3 != null"><v-btn color="orange" dark class="elevation-0 ma-0 bold"><v-icon class="ma-0 mr-2" small>cloud_download</v-icon> Faktura</v-btn>
              </a>
            </td>
            <td class="text-xs-right">
              <button-link color="orange" :to="{ path: '/obchody-a-provize/' + props.item.rok + '/' + props.item.mesic }" dark class="elevation-0 ma-0 bold"><v-icon class="ma-0">remove_red_eyes</v-icon> Detail</button-link>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import Base from '../Base'
  import DateRangePicker from '@/components/DateRange';
  export default {
    extends: Base,
    data () {
      return {
        loading: true,
        loadingTable: false,
        search: "",
        obdobiHeaders: [
          { text: 'Období', value: 'datum', sortable: false },
          { text: 'Objem obchodů', value: 'objem_obchodu', sortable: false, align: 'right' },
          { text: 'Kredity', value: 'celkem_kredity', sortable: false, align: 'right' },
          { text: 'Hodnota kreditu', value: 'hodnota_kreditu', sortable: false, align: 'right' },
          { text: 'Celková provize', value: 'celkem_castka', sortable: false, align: 'right' },
          { text: 'Faktura', value: 'faktura_s3', sortable: false, align: 'center' },
          { text: '', value: 'id', sortable: false, width: '100px' }
        ],
        headers: [
          { text: 'Datum', value: 'datum', sortable: false },
          { text: 'Klient', value: 'klient', sortable: false },
          { text: 'Podřízený spolupracovník', value: 'podrizeny_pracovnik', sortable: false },
          { text: 'Typ obchodu', value: 'ucel_platby', sortable: false, align: 'left' },
          { text: 'Objem obchodu', value: 'castka', sortable: false, align: 'right' },
          { text: 'Kredity', value: 'kredity', sortable: false, align: 'right' },
          { text: 'Hodnota kreditu', value: 'hodnota_kreditu', sortable: false, align: 'right' },
          { text: 'Provize', value: 'castka', sortable: false, align: 'right' }
        ],
        vyuctovani_provize_headers: [
          { text: 'Typ', value: 'typ_polozky', sortable: false },
          { text: 'Částka', value: 'castka', sortable: false, align: 'right' }
        ],
        items: [],
        nezauctovane: null,
        zauctovane: null,
        zauctovane_obdobi: [],
        timeout: null,
        counter: 0,
        pagination: {
          descending: true,
          page: 1,
          rowsPerPage: 25,
          sortBy: "id",
          totalItems: 0,
          pages: 0
        },
        totalItems: 0,
        obdobi_ke_schvaleni: null,
        dialogInvoice: false,
        savingApproval: false,
        savingDeny: false,
        downloadXlsx: false,
        datum_od: null,
        datum_do: null,
        dateRangeOptions: {
          startDate: moment().startOf("month").format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
          format: 'DD.MM.YYYY',
          presets: [
            {
              label: 'Dnes',
              range: [
                moment().format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD'),
              ],
            },
            {
              label: 'Tento měsíc',
              range: [
                moment().startOf("month").format('YYYY-MM-DD'),
                moment().endOf("month").format('YYYY-MM-DD'),
              ],
            },
            {
              label: 'Minulý měsíc',
              range: [
                moment().subtract("months", 1).startOf("month").format('YYYY-MM-DD'),
                moment().subtract("months", 1).endOf("month").format('YYYY-MM-DD'),
              ],
            },
            {
              label: 'Tento rok',
              range: [
                moment().startOf("year").format('YYYY-MM-DD'),
                moment().endOf("year").format('YYYY-MM-DD'),
              ],
            },
            {
              label: 'Minulý rok',
              range: [
                moment().subtract("years", 1).startOf("year").format('YYYY-MM-DD'),
                moment().subtract("years", 1).endOf("year").format('YYYY-MM-DD'),
              ],
            }
          ],
        },
        range: [],
        labels: {
          start: "Začátek",
          end: "Konec"
        },
        menu: false,
        datum: null,
      }
    },
    watch: {
      pagination: {
    		handler: function(newValue) {
          if (!this.loadingTable)
    			   this.loadTable();
    		},
    		deep: true
    	},
      search () {
        this.queryList();
      },
      datum_od () {
        this.datum = moment(this.datum_od*1000).format("DD.MM.YYYY") + " - " + moment(this.datum_do*1000).format("DD.MM.YYYY");
      },
      datum_do () {
        this.datum = moment(this.datum_od*1000).format("DD.MM.YYYY") + " - " + moment(this.datum_do*1000).format("DD.MM.YYYY");
      }
    },
    mounted () {
      this.load();
      this.loadTable();
      this.datum_od = parseInt(moment().startOf("month")._d.getTime()/1000);
      this.datum_do = parseInt(moment()._d.getTime()/1000);
      this.datum = moment(this.datum_od).format("DD.MM.YYYY") + " - " + moment(this.datum_do).format("DD.MM.YYYY");
    },
    computed: {
      me () {
        return window.$me;
      }
    },
    methods: {
      queryList: function() {
        if (this.timeout != null)
          clearTimeout(this.timeout);
        this.timeout = setTimeout(function() {
          this.pagination.page = 1;
          this.loadTable();
        }.bind(this), 200)
      },
      load (f) {
        this.loading = true;
        this.loadingTable = true;
        if (window.$user.tipar) {
          this.headers[2].text = "Obchodník";
        }
        window.API.get("obchody/provize").then(function(body) {

          this.nezauctovane = body.nezauctovane;
          this.zauctovane = body.zauctovane;
          this.zauctovane_obdobi = body.zauctovane_obdobi;
          this.obdobi_ke_schvaleni = body.obdobi_ke_schvaleni;

          /*this.items = body.nezauctovane_obdobi.data;
          this.pagination.sortBy = body.nezauctovane_obdobi.sort.sortBy;
          this.pagination.descending = body.nezauctovane_obdobi.sort.descending;
          this.pagination.page = body.nezauctovane_obdobi.sort.page;
          this.pagination.rowsPerPage = body.nezauctovane_obdobi.sort.rowsPerPage;
          this.totalItems = body.nezauctovane_obdobi.sort.totalItems;
          this.pagination.pages = body.nezauctovane_obdobi.sort.pages;*/

          this.loadingTable = false;
          this.loading = false;

        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      },
      loadTable (f) {
        this.counter++;
        this.loadingTable = true;
        //this.items = [];
        window.API.post("obchody/provize/nezuctovane/search", {
          pagination: this.pagination,
          s: this.search,
          echo: this.counter
        }).then(function(body) {
          if (this.counter != body.echo)
            return;
          this.items = body.data;
          this.pagination.sortBy = body.sort.sortBy;
          this.pagination.descending = body.sort.descending;
          this.pagination.page = body.sort.page;
          this.pagination.rowsPerPage = body.sort.rowsPerPage;
          this.totalItems = body.sort.totalItems;
          this.pagination.pages = body.sort.pages;
          //this.loading = false;
          this.loadingTable = false;
          if (typeof f === "function")
            f();
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      },
      detailClick (v) {

      },
      approveInvoice () {
        this.savingApproval = true;
        window.API.get("obchody/provize/" + this.obdobi_ke_schvaleni.id + "/faktura/souhlas").then(function(body) {
          this.savingApproval = false;
          if (body.updated) {
            this.dialogInvoice = false;
            this.obdobi_ke_schvaleni = null;
            this.load();
            this.loadTable();
          }
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      },
      denyInvoice () {
        this.savingDeny = true;
        window.API.get("obchody/provize/" + this.obdobi_ke_schvaleni.id + "/faktura/nesouhlas").then(function(body) {
          this.savingDeny = false;
          if (body.updated) {
            this.dialogInvoice = false;
            this.obdobi_ke_schvaleni = null;
          }
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      },
      onDateRangeChange (e) {
        this.datum_od = parseInt(moment(e[0]).startOf("day")._d.getTime()/1000);
        this.datum_do = parseInt(moment(e[1]).endOf("day")._d.getTime()/1000);
        this.obdobi = null;
        this.load();
      },
      download () {
        window.api.download("obchody/provize/prehled-obchodu/xlsx?datum_od={0}&datum_do={1}".format(this.datum_od, this.datum_do));
      }
    },
    components: {
      DateRangePicker
    }
  }
</script>
